function split(term: string) {
  if (term) {
    return term.split(/[\s,]+/);
  }
  return [];
}

export default split;
